<template>
  <div>
    <el-row>
      <el-col :offset="12" :span="12" class="box">
        <div class="numBox">
          <span>有码总条数：<span style="color:blue">{{ data.length }} </span>条</span>
        </div>
        <div class="numBox">  
          <span>已核验条数：<span style="color:blue">{{ verificationNum }} </span>条</span>
        </div>
        <el-input v-model="input"  placeholder="扫码核验，请扫追溯码" ref="no" @input="handleInput"
          ></el-input>
        <el-button style="margin-left: 10px;" size="medium" type="primary" @click="reset">重置</el-button>
      </el-col>
    </el-row>
     

  </div>
</template>
<script>
import GetDataMixin from "@/mixin/getData-mixin.js";

import { Debounce } from "@/utils/utils";
export default {
  props:['data'],
  mixins: [ GetDataMixin],
  data(){
    return{
       input:'',
       verificationNum:0
    }
  },
  methods:{
    handleInput:Debounce(function (val){
      this.mainNoChange(val)
      this.$forceUpdate();
    }),
    mainNoChange(val){
      
      // 去掉空格
      val = val.replace(/\s+/g, "").toUpperCase()
        if (!val || val == '') {
          return;
      }

      this.data.forEach(res => {
        if(res.traceNo==val){
          if(res.verification==true){
            this.$my_message(`已验收过该条产品`, "warning");
          }else{
            res.verification = true
            this.$emit('verificationEvt', res);
            this.input = ''
            this.verificationNum ++
          }
      
        }
      });
      
      
    },
    reset(){
      this.input = '';
    }
  }
}
</script>

<style lang="scss" scoped>
  .box{
    display: flex;
    justify-content:space-evenly;
    align-items: center;
    margin-bottom: 10px;
    .numBox{
        width: 50%;
        margin:  0 15px;
    }
  }
</style>